module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	'use strict';
	fox.registerWidget('Layout_Join', {
	
	}, 'Site_Layout');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/layout/join.js
// module id = 1252
// module chunks = 4